var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('Sidebar'),_c('Header'),_c('div',{staticClass:"router-view-area",class:_vm.$store.state.sidebarToggled ? 'fully-opened-sidebar' : ''},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }